"use client";
import { cva as o } from "class-variance-authority";
const n = o([
  "transition-[common] ease-out duration-[180]",
  "cursor-pointer text-decoration-none break-words",
  "outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent",
  "hover:underline"
]);
export {
  n as link
};
